import axios from 'axios';
import { buildApiUrl } from '../utils/apiUrl';
import { TIMEOUTS } from '../config/timeouts';

/**
 * Last opp .docx eller .pdf og hent AI-forslag til målrettingsfelt.
 * @param {File} file
 * @returns {Promise<{ fields: {
 *   malGeo: string,
 *   geoAge: string,
 *   wishesDemands: string,
 *   skillsTitles: string,
 *   companies: string,
 *   industryInterests: string,
 *   hybridHome: boolean,
 * }, inferred: Record<string, boolean> }>}
 */
export async function suggestTargetingFromDocument(file) {
	const formData = new FormData();
	formData.append('document', file);
	const { data } = await axios.post(
		buildApiUrl('form/ai-suggest-targeting'),
		formData,
		{ timeout: TIMEOUTS.formAiSuggestTimeoutMs }
	);
	return data;
}

/**
 * Scrape en offentlig stillingslenke og hent AI-forslag til målrettingsfelt.
 * @param {string} url
 * @returns {Promise<{ fields: {
 *   malGeo: string,
 *   geoAge: string,
 *   wishesDemands: string,
 *   skillsTitles: string,
 *   companies: string,
 *   industryInterests: string,
 *   hybridHome: boolean,
 * }, inferred: Record<string, boolean> }>}
 */
export async function suggestTargetingFromUrl(url) {
	const { data } = await axios.post(
		buildApiUrl('form/ai-suggest-targeting'),
		{ url },
		{ timeout: TIMEOUTS.formAiSuggestTimeoutMs }
	);
	return data;
}
